<template>
  <va-list>
    <div class="relaxation-protocol-selector">
      <va-select
        label="Relaxtion Protocol Day"
        v-model="selectModel"
        textBy="description"
        :options="selectOptions"
        :clear="false"
      />
    </div>
    <va-item v-for="step in selectedDay.steps" v-bind:key="step.id" >
      <va-item-section side>
        <va-checkbox v-model="step.value" />
      </va-item-section>

      <va-item-section>
        <va-item-label>{{step.label}}</va-item-label>
      </va-item-section>
    </va-item>
  </va-list>
</template>

<script>
import relaxation from '../../data/relaxation.json'

export default {
  name: 'relaxation-protocol-card',
  data () {
    return {
      selectModel: { id: 0, description: 'Day 1' },
      selectedDay: relaxation.relaxation[0],
    }
  },
  computed: {
    selectOptions: function () {
      const selectArray = []
      relaxation.relaxation.forEach((day, index) => {
        const daySelectOption = { id: index, description: `Day ${index + 1}` }
        selectArray.push(daySelectOption)
      })

      return selectArray
    },
  },
  watch: {
    selectModel: function () {
      const selectedDay = this.selectModel.id

      this.selectedDay = relaxation.relaxation[selectedDay]
    },
  },
}
</script>

<style lang="scss">
  .va-card {
    &__body {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .relaxation-protocol-selector {
        width: 80%;

        .va-select__clear-icon {
          display: none;
        }
      }

      .va-item {
        width: 100%;

        &-label {
          overflow: unset;
          white-space: break-spaces;
          text-align: left;
        }
      }
    }
  }
</style>
